import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {RouterModule, Routes} from '@angular/router';

import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import {HeaderComponent} from './header/header.component';

import {ProjectDetailComponent} from './project-detail/project-detail.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {CollectionComponent} from './collection/collection.component';
import {CollectionsComponent} from './collections/collections.component';
import {FooterComponent} from './footer/footer.component';
//--------------ABOUT--
import {AboutComponent} from './about/about.component';
import {ContactComponent} from './contact/contact.component';
import {ExperienceComponent} from './experience/experience.component';

import {DatabaseService} from './database.service';

import {SwiperModule} from 'ngx-swiper-wrapper';
import {SWIPER_CONFIG} from 'ngx-swiper-wrapper';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';



const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    keyboard: true
};

const appRoutes: Routes = [
    {path: 'collection/:slug', component: CollectionComponent},
    {path: 'collections', component: CollectionsComponent},
    {path: 'about', component: AboutComponent},
    {path: 'experience', component: ExperienceComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'collection/:collectionSlug/:projectSlug', component: ProjectDetailComponent},
    // {
    //   path: 'collection',
    //   component: CollectionComponent,
    //   data: { title: 'Colecciones' }
    // },
    {path: 'home', component: HomeComponent},
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {path: '**', component: PageNotFoundComponent}
];



@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        ProjectDetailComponent,
        PageNotFoundComponent,
        CollectionComponent,
        AboutComponent,
        ContactComponent,
        ExperienceComponent,
        CollectionsComponent,
        FooterComponent,
    ],
    imports: [
        RouterModule.forRoot(
            appRoutes,
            {
                enableTracing: false,
                useHash: true
            } // <-- debugging purposes only
        ),
        BrowserModule,
        // BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        SwiperModule
    ],
    providers: [
        DatabaseService,
        {
            provide: SWIPER_CONFIG,
            useValue: DEFAULT_SWIPER_CONFIG
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts